import { render } from "./AddComplianceSubjectModal.vue?vue&type=template&id=b1244f3a&scoped=true"
import script from "./AddComplianceSubjectModal.vue?vue&type=script&lang=js"
export * from "./AddComplianceSubjectModal.vue?vue&type=script&lang=js"

import "./AddComplianceSubjectModal.vue?vue&type=style&index=0&id=b1244f3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1244f3a"]])

export default __exports__